var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class t {
  static set(t2) {
    this.instance = t2;
  }
  static get() {
    return this.instance;
  }
}
__publicField(t, "instance", null);
export {
  t as AuthManager
};
//# sourceMappingURL=AuthManager.js.map
